import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

const AIAssistantChatHistoryLoader = () => {
  return (
    <Stack direction='row' justifyContent='center' data-testid='conversation-list-loader'>
      <CircularProgress sx={{
        '& .MuiCircularProgress-svg': {
          height: 'auto',
          width: 'auto',
        },
      }} />
    </Stack>
  );
};

export default AIAssistantChatHistoryLoader;
